<script setup>
import {reactive,onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";
import {Permissions} from "@/Utils/Permissions";

const props = defineProps({
  contextIdA: String,
  contextIdB: String
});

const data = reactive({
  date: null,
  items: [
    {
      text: 'Disbursements',
      value: '0'
    },
    {
      text: 'Holdbacks',
      value: '0'
    },
    {
      text: 'Released Holdbacks',
      value: '0'
    },
    {
      text: 'Net Pay',
      value: '0'
    }
  ]
})

onMounted(()=>{

  // Show adjustments
  if(Permissions.checkPermissions(['my-pay-period.adjustments'])) {
    data.items = [
      {
        text: 'Disbursements',
        value: '0'
      },
      {
        text: 'Holdbacks',
        value: '0'
      },
      {
        text: 'Released Holdbacks',
        value: '0'
      },
      {
        text: 'Adjustments',
        value: '0'
      },
      {
        text: 'Net Pay',
        value: '0'
      }
    ];
  }
  else {
    data.items = [
      {
        text: 'Disbursements',
        value: '0'
      },
      {
        text: 'Holdbacks',
        value: '0'
      },
      {
        text: 'Released Holdbacks',
        value: '0'
      },
      {
        text: 'Net Pay',
        value: '0'
      }
    ];
  }

  const contextIdA = props.contextIdA;
  const contextIdB = props.contextIdB;
  // No contextIdB (personId) provided, look at logged in user
  if(!contextIdB){
    ApiWrapper.post(
            'pay-period',
            'my-pay-period',
            {payPeriodId: contextIdA}
        )
        .then((response) => {
          if(response.rows.length > 0) {
            if(Permissions.checkPermissions(['my-pay-period.adjustments'])) {
              data.date = response.rows[0].date;
              data.items[0].value = response.rows[0].disbursements;
              data.items[1].value = response.rows[0].holdbacks;
              data.items[2].value = response.rows[0].holdbacksreleased;
              data.items[3].value = response.rows[0].adjustments;
              data.items[4].value = response.rows[0].net;
            }
            else {
              data.date = response.rows[0].date;
              data.items[0].value = response.rows[0].disbursements;
              data.items[1].value = response.rows[0].holdbacks;
              data.items[2].value = response.rows[0].holdbacksreleased;
              data.items[3].value = response.rows[0].net;
            }
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
  }else{
    ApiWrapper.get(
            'pay-period',
            'stat-card','payPeriodId=' + contextIdA + '&personId=' + contextIdB
        )
        .then((response) => {
          if(Permissions.checkPermissions(['my-pay-period.adjustments'])) {
            data.date = response.date;
            data.items[0].value = response.disbursements;
            data.items[1].value = response.holdbacks;
            data.items[2].value = response.holdbacksReleased;
            data.items[3].value = response.adjustments;
            data.items[4].value = '$' + parseFloat(Math.round(response.net * 100) / 100).toFixed(2);
          }
          else {
            data.date = response.date;
            data.items[0].value = response.disbursements;
            data.items[1].value = response.holdbacks;
            data.items[2].value = response.holdbacksReleased;
            data.items[3].value = '$' + parseFloat(Math.round(response.net * 100) / 100).toFixed(2);
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
  }
})
</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Pay Period Stats</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>

      <v-row density="compact">
        <v-col cols="12" sm="12">
          <h3 class="px-5" style="text-align: left">{{data.date}}</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12">
          <v-list density="compact" class="px-5" width="auto">
            <v-list-item v-model="data.items" color="primary">
              <template v-for="(item, index) in data.items" :key="item">
                <v-list-item>
                  <v-list-item-title class="mt-2"
                  >
                    <v-row>
                      <v-col cols="6">{{item.text}}</v-col>
                      <v-col cols="6" style="text-align: right">{{item.value}}</v-col>
                    </v-row>
                  </v-list-item-title>
                </v-list-item>
                <v-divider
                    v-if="index + 1 < data.items.length"
                    :key="index"
                ></v-divider>
              </template>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>